/*
 * Copyright (c) 2024. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {Article} from "types/entities/Article";
import {ShoppingCartItem} from "types/entities/ShoppingCartItem";
import ArticleRow from "pages/Front/Registration/components/ProductSelection/components/ArticleRow";
import {useTypedSelector} from "helpers/reducers";
import {UserIcon} from "@heroicons/react/24/solid";
import {Driver} from "types/entities/Driver";

interface DriverRowProps {
    account: Driver;
    driverShoppingCartItems: ShoppingCartItem[] | [];
    isLoading: boolean;
    onSelect: (article: Article, account_id: number, shoppingCartItem: ShoppingCartItem | null, quantity: number) => void;
    useQuantity?: boolean;
    useRemove?: boolean;
    onRemove?: (shoppingCartItem: ShoppingCartItem) => void;
}

const DriverRow = (props: DriverRowProps) => {
    const articles = useTypedSelector(state => state.articlesState.articlesKiosk);

    const onSelectHandler = (article: Article, shoppingCartItem: ShoppingCartItem | null, quantity: number) => {
        props.onSelect(article, props.account.id, shoppingCartItem, quantity);
    };

    return (
        <div className={"flex flex-row justify-center items-center w-full mb-6 bg-white overflow-hidden border border-white rounded-3xl shadow"}>
            <div className={"flex h-full justify-center items-center max-w-[3.1rem] w-full"}>
                <span className={"uppercase text-sm font-thin -rotate-90 transform-gpu text-black text-opacity-50"}>{props.account.user_type}</span>
            </div>
            <div className={"grid grid-cols-7 pl-0 pr-5 py-3 w-full"}>
                <div className={"col-span-2 text-center pr-3"}>
                    <div className={"flex flex-row items-center h-full w-full "}>
                        <span className={"inline-flex border border-white/80 bg-white/20 shadow rounded-xl p-2"}>
                            <UserIcon className={"w-9 h-9 text-black"} />
                        </span>
                        <p className={"ml-6 font-thin text-base truncate"}>
                            {props.account.name} <br />
                            <strong className={"font-bold"}>"{props.account.nickname}"</strong> <br />
                            {props.account.last_name}
                        </p>
                    </div>
                </div>
                <div className={"col-span-5 text-right"}>
                    {articles &&
                        articles
                            .filter(article => article.person_type === props.account.person_type)
                            .map((article, articleIndex) => {
                                return (
                                    <ArticleRow
                                        key={articleIndex}
                                        account={props.account}
                                        article={article}
                                        driverShoppingCartItems={props.driverShoppingCartItems}
                                        isLoading={props.isLoading}
                                        useQuantity={props.useQuantity}
                                        useRemove={props.useRemove}
                                        onRemove={props.onRemove}
                                        onSelect={onSelectHandler}
                                    />
                                );
                            })}
                </div>
            </div>
        </div>
    );
};

export default DriverRow;
